export enum ReservedKind {
  None = 'None',
  Reservation = 'Reservation',
  Maintenance = 'Maintenance'
}



// WEBPACK FOOTER //
// ./src/shared/reservedKind/reservedKind.ts